import { get } from "utilities/network";

export const httpGetSupport = () => {
  return get("support/auth/me");
};
